import ProductPlaceholderImage from './ProductPlaceholderImage.vue'

export default ProductPlaceholderImage
